import React from "react";
import { Link } from "react-router-dom";
import SearchBar from "./SearchBar";
import daricheLogo from "../assets/images/dariche-logo.png";

// Shared header for every Section A (public) page: logo, site nav, and
// the title/author search. There's no public account system — the only
// auth-aware bit is a "پنل مدیریت" shortcut shown if an admin is already
// signed in (from a previous /admin visit); everyone else just gets the
// plain public nav.
function SiteHeader() {
  const isAdmin = localStorage.getItem("role") === "admin";

  return (
    <header className="site-header">
      <Link to="/" className="site-logo">
        <img src={daricheLogo} alt="مجلهٔ دریچه" />
      </Link>

      <nav className="site-nav">
        <Link to="/about">درباره ما</Link>
        <Link to="/ravaq">رواق</Link>
        <Link to="/publications">نشریه‌ها</Link>
        <Link to="/contact">ارتباط با ما</Link>
      </nav>

      <nav className="site-auth">
        <SearchBar />
        {isAdmin && <Link to="/admin">پنل مدیریت</Link>}
      </nav>
    </header>
  );
}

export default SiteHeader;
